/* eslint-disable */

import { config } from './config';

export async function saveFeedback(uuid, token, autosave, data) {
    const headers = new Headers({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-oh-feedback-token': token,
    });
    const res = await fetch(`${config().apiHost}/feedback/${uuid}`, {
        method: 'PATCH',
        headers,
        body: JSON.stringify({
            autosave,
            response_data: data,
        }),
    });
    if (res.status === 200) {
        return res.json();
    }
    throw Error(res.status);
}

export async function getFeedback(uuid, token) {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-oh-feedback-token': token,
    };
    const res = await fetch(`${config().apiHost}/feedback/${uuid}`, {
        method: 'GET',
        headers,
    });
    if (res.status === 200) {
        return res.json();
    }
    throw Error(res.status);
}
